import { render } from "./CalendarView.vue?vue&type=template&id=55f1b8ec&ts=true"
import script from "./CalendarView.vue?vue&type=script&lang=ts"
export * from "./CalendarView.vue?vue&type=script&lang=ts"

import "./CalendarView.vue?vue&type=style&index=0&id=55f1b8ec&lang=css"

import exportComponent from "D:\\Development\\Casa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__